
<br />
<div class="successstep text-center margin-top-0" *ngIf="!showAssignTask && loggedInUserIsPropertyBroker && !taskAdded">
  <h4 class="margin-top-10">There are no existing tasks against this Offer.</h4>
  <a class="bluelink" (click)="onShowAssignTask();">Click here to add and assign new task.</a>
  <!--<div class="text-center margin-top-20">
      <button class="btn btn-success  btn-lg" (click)="onShowAssignTask();">Assign Task</button>
  </div>-->
</div>

<div class="featuredproperties" *ngIf="taskAdded" id="divOfferTaskList">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 ">
        <div>
          <div>
            <div class="text-right margin-bottom-15 cf">
              <label class="pull-left add-event">
                <label class="custom-checkbox" style="    margin-bottom: 2px;margin-left: 5px;padding-left: 25px;top: -2px;">
                  <label></label>
                  <input type="checkbox" (change)="addAllEvents()" [(ngModel)]="eventCheckbox">
                  <i></i>
                </label>
                Add All Events To Calendar
                <!--<span class="fa fa-calendar-plus-o" aria-hidden="true"></span>-->
              </label>

              <a class="btn  btn-circle btn-green" (click)="openModal(AddTask,'panlestyle');" *ngIf="AllowEdit" tooltip="Add Task" placement="left"><i aria-hidden="true" class="icofont icofont-plus icon"></i></a>
            </div>
            <div class="table-responsive">

              <table class="table basictable featuredproperties-table">


                <thead>
                  <tr>
                    <th style="width:100px;">Actions</th>
                    <th style="width:300px">Phases/Tasks</th>
                    <th style="width:200px">Status</th>
                    <th style="width:170px">Start Date</th>
                    <th style="width:170px">End Date</th>
                    <th style="width:180px">Assignee</th>

                    <!--*ngIf="AllowEdit"-->
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let associated of associatedTask;let i = index;">
                    <tr class="newthstyle">
                      <td style="width:100px;" class="whitespacenowrap">
                        <a *ngIf="AllowEdit" class="blueone margin-left-32" href="javascript:void(0);" (click)="LoadPhaseDataToEdit(AddTaskPhase,'panlestyle',associated.TableId);" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
                        <label class="add-event-tag" tooltip="Add Event To Calendar" *ngIf="!associated.IsCalenderEventAdded">
                          <label class="custom-checkbox" style="margin-bottom:15px;margin-left:5px;">
                            <input type="checkbox" (change)="AddCalenderEvent(0, associated.TableId, associated.IsCalenderEventAdded)" [(ngModel)]="associated.IsCalenderEventAdded">
                            <i></i>
                          </label>
                          <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                        </label>
                        <label class="add-event-tag remove-tag" tooltip="Remove Event from Calendar" *ngIf="associated.IsCalenderEventAdded">
                          <label tooltip="Remove Event from Calendar" class="custom-checkbox" style="margin-bottom:15px;margin-left:5px;">
                            <input type="checkbox" (change)="AddCalenderEvent(0, associated.TableId, associated.IsCalenderEventAdded)" [(ngModel)]="associated.IsCalenderEventAdded">
                            <i></i>
                          </label>
                          <i class="fa fa-calendar-times-o" aria-hidden="true"></i>
                        </label>
                        <a *ngIf="AllowEdit" class="remove" href="javascript:void(0);" (click)="openPhaseDeleteModal(DeletePhaseModal,'deletemodal',associated.TableId)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                      </td>
                      <td style="width:320px">
                        <p class="d-flex headstyle">
                          <span class="btn-collapse" [class.span-open]="associated.ShowSubTask" (click)="showTaskList(associated.Id,i)">
                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                          </span>
                          {{associated.Name}}
                          <span class="msg-wrap"  *ngIf="associated.TotalNoteCount!=undefined&&associated.TotalNoteCount!=null&&associated.TotalNoteCount>0">
                            <span tooltip="Notes" placement="top" class="bluetwo"><i class="fa fa-file-text"></i></span>
                            <sup class="note-count-unread note-count count-n1" title="Unread"> {{associated.TotalNoteCount!=undefined&&associated.TotalNoteCount!=null ? associated.TotalNoteCount:0}} </sup>
                          </span>
                        </p>
                      </td>
                      <td style="width:200px">
                        {{associated.IsPhaseCompleted ? 'Completed':'Pending'}}
                        <span style="float:right">
                          <a class="graybtn" href="javascript:void(0);" *ngIf="associated.IsPhaseCompleted" tooltip="completed"><i aria-hidden="true" class="icon-tick2"></i></a>
                          <a class="blueone" href="javascript:void(0);" *ngIf="!associated.IsPhaseCompleted" (click)="changePhaseStatus(associated.TableId,$event);" tooltip="Change to Completed"><i aria-hidden="true" class="icon-tick2"></i></a>
                        </span>
                      </td>
                      <td style="width:170px">
                        <p>{{associated.StartDate| date:'MM/dd/yyyy'}}</p>
                      </td>
                      <td style="width:170px">
                        <p>{{associated.EndDate | date:'MM/dd/yyyy'}}</p>
                      </td>
                      <td style="width:180px">-</td>

                    </tr>
                    <ng-container *ngIf="associated.ShowSubTask">
                      <tr *ngFor="let item of taskList|arrayfilter: 'AssociatedStatusId':associated.Id">
                        <td class="whitespacenowrap">
                          <div class="msg-wrap" >
                            <a [ngClass]="{'newnote': item.UnReadNoteCount!=0}" href="javascript:void(0);" (click)="openModalForNotes(notestemplate,'panlestyle sharednotesmodal',item, associated.Name)" tooltip="Notes" placement="top" class="bluetwo" ><i class="icon-inquiry"></i></a>
                            <sup class="note-count-unread note-count count-n1" title="Unread" *ngIf="item.TotalNote!=undefined&&item.TotalNote!=null&&item.TotalNote>0"> {{item.TotalNote!=undefined&&item.TotalNote!=null ? item.TotalNote:0}} </sup>
                          </div>
                          <a class="blueone" href="javascript:void(0);" *ngIf="AllowEdit" (click)="LoadTaskDataToEdit(EditTaskModal,'panlestyle',item.LeadCheckListId);" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
                          <label class="add-event-tag" tooltip="Add Event To Calendar" *ngIf="item.IsCalenderEventAdded != null && !item.IsCalenderEventAdded">
                            <label class="custom-checkbox" style="margin-bottom:15px;margin-left:5px;">
                              <input type="checkbox" (change)="AddCalenderEvent(item.LeadCheckListId, 0, item.IsCalenderEventAdded)" [(ngModel)]="item.IsCalenderEventAdded">                          <i></i>
                            </label>
                            <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                          </label>
                          <label class="add-event-tag remove-tag" tooltip="Remove Event from Calendar" *ngIf="item.IsCalenderEventAdded != null && item.IsCalenderEventAdded">
                            <label tooltip="Remove Event from Calendar" class="custom-checkbox" style="margin-bottom:15px;margin-left:5px;">
                              <input type="checkbox" (change)="AddCalenderEvent(item.LeadCheckListId, 0, item.IsCalenderEventAdded)" [(ngModel)]="item.IsCalenderEventAdded">
                              <i></i>
                            </label>
                            <i class="fa fa-calendar-times-o" aria-hidden="true"></i>
                          </label>
                          <a class="remove margin-left-32" href="javascript:void(0);" *ngIf="item.IsCalenderEventAdded == null && AllowEdit" (click)="openDeleteModal(DeleteModal,'deletemodal',item.LeadCheckListId)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                          <a class="remove" href="javascript:void(0);" *ngIf="item.IsCalenderEventAdded != null && AllowEdit" (click)="openDeleteModal(DeleteModal,'deletemodal',item.LeadCheckListId)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                        </td>
                        <td><p>{{item.TaskName}}</p></td>
                        <td class="whitespacenowrap">
                          <p>
                            {{item.StatusName}}
                            <span style="float:right">
                              <a class="graybtn" href="javascript:void(0);" *ngIf="item.Status === 2252" tooltip="completed"><i aria-hidden="true" class="icon-tick2"></i></a>
                              <a class="bluetwo" href="javascript:void(0);" *ngIf="item.Status !== 2252" (click)="changeOfferStatus(item.LeadCheckListId);" tooltip="Change to Completed"><i aria-hidden="true" class="icon-tick2"></i></a>
                            </span>

                            <!--[disabled]="item.AssigneeId !== user.Id"-->
                            <!--<label class="select">
                      <select class="form-control" [disabled]="!AllowEdit" (change)="onChangeStatus(item.LeadCheckListId,item.Status);" [(ngModel)]="item.Status">
                          <option *ngFor="let status of lookupList" [(ngValue)]="status.id">{{status.description}}</option>
                      </select>
                      <i></i>
                  </label>-->
                        </td>

                        <td><p>{{item.StartDate}}</p></td>
                        <td><p>{{item.EndDate}}</p></td>
                        <td>
                          <p> {{item.Assignee ? item.Assignee : '-'}}</p>


                        </td>

                      </tr>
                      <!--<tr>
                <td style="background-color:white !important" colspan="7">
                    <div style="height:5px"></div>
                </td>
            </tr>-->
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>

            </div>

            <ng-template #notestemplate>
              <app-shared-add-notes (close)="closeModal($event)" [modalRef]="modalRef" [notesInputsModel]="NotesInput"></app-shared-add-notes>
            </ng-template>


            <ng-template #DeleteModal>
              <div class="modal-header">
                <h4 class="modal-title pull-left">Delete Task</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body padding30">
                <div class="form-group">
                  <h6 class="displayvalue">Are you sure you'd like to delete this task ?</h6>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
                  <button class="btn btn-lg btn-danger" (click)="onTaskDelete();modalRef.hide();">Delete</button>
                </div>
              </div>
            </ng-template>

            <ng-template #DeletePhaseModal>
              <div class="modal-header">
                <h4 class="modal-title pull-left">Delete Associated Category</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body padding30">
                <div class="form-group">
                  <h6 class="displayvalue">Are you sure to delete this associated category and its associated tasks ?</h6>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
                  <button class="btn btn-lg btn-danger" (click)="onPhaseDelete();modalRef.hide();">Delete</button>
                </div>
              </div>
            </ng-template>

            <ng-template #EditTaskModal class="pull-left">

              <div class="modal-header">
                <h4 class="modal-title pull-left">Edit Task Details</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form [formGroup]="EditTaskForm" autocomplete="off">
                  <div class="form-group">
                    <label class="form-label">Task Name<span class="star">*</span></label>
                    <input class="form-control" [readonly]="disableAdminCreatedTaskControls" formControlName="txtTaskname" [(ngModel)]="LeadCheckListEditModel.TaskName" maxlength="100" required type="text">
                    <div *ngIf="(txtTaskname.invalid && isEditTaskFormSubmitted )||(txtTaskname.invalid && (txtTaskname.dirty || txtTaskname.touched))">
                      <p class="redtext" *ngIf="txtTaskname.errors.required">
                        Task Name is required
                      </p>
                      <p class="redtext" *ngIf="txtTaskname.errors.minlength">
                        Task Name must be at least 2 characters long
                      </p>
                      <p class="redtext" *ngIf="txtTaskname.errors.spaceOnly">
                        The value cannot be only white spaces
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Start Date
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="txtStartDate" [(ngModel)]="LeadCheckListEditModel.StartDate" class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="(txtStartDate.invalid && isEditTaskFormSubmitted )||(txtStartDate.invalid && (txtStartDate.dirty || txtStartDate.touched))">
                        <p class="redtext" *ngIf="LeadCheckListEditModel.StartDate =='Invalid Date' ">
                          Invalid Start Date
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      End Date
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="txtEndDate" [(ngModel)]="LeadCheckListEditModel.EndDate" class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="(txtEndDate.invalid && isEditTaskFormSubmitted )||(txtEndDate.invalid && (txtEndDate.dirty || txtEndDate.touched))">
                        <p class="redtext" *ngIf="LeadCheckListEditModel.EndDate =='Invalid Date' ">
                          Invalid End Date
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Associated Category
                      <span class="star">*</span>
                    </label>
                    <label class="select">
                      <!--[attr.disabled]="disableAdminCreatedTaskControls"-->
                      <select formControlName="AssociatedStatus" [(ngModel)]="LeadCheckListEditModel.AssociatedStatusId" class="form-control">
                        <option value="0">--Select--</option>
                        <option [ngValue]="asl.id" *ngFor="let asl of associatedStatusList">{{asl.description}}</option>
                      </select>
                      <i></i>
                    </label>
                    <div *ngIf="(isEditTaskFormSubmitted) || (AssociatedStatus.dirty || AssociatedStatus.touched)">
                      <p class="redtext" *ngIf="LeadCheckListEditModel.AssociatedStatusId === '0'">
                        Associated Category is required
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Responsible Role
                      <!--<span class="star">*</span>-->
                    </label>
                    <label class="select">
                      <select [(ngModel)]="LeadCheckListEditModel.ResponsibleRoleId" formControlName="UserRole" (change)="bindAssignee(LeadCheckListEditModel.ResponsibleRoleId,0)" class="form-control">
                        <option value="0">--Select--</option>
                        <option [ngValue]="item.id" *ngFor="let item of userRoleList">{{item.name}}</option>
                      </select>
                      <i></i>
                    </label>
                    <!--<div *ngIf="(isEditTaskFormSubmitted) || (UserRole.dirty || UserRole.touched)">
              <p class="redtext" *ngIf="LeadCheckListEditModel.ResponsibleRoleId === '0'">
                  Responsible Role is required
              </p>
          </div>-->
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Assignee
                      <!--<span class="star">*</span>-->
                    </label>
                    <label class="select">
                      <select [(ngModel)]="LeadCheckListEditModel.AssigneeId" formControlName="Assignee" class="form-control">
                        <option value="0">--Select--</option>
                        <option [ngValue]="assignee.UserId" *ngFor="let assignee of assigneeList">{{assignee.UserName}}</option>
                      </select>
                      <i></i>
                    </label>

                    <!--<div *ngIf="(isEditTaskFormSubmitted) || (Assignee.dirty || Assignee.touched)">
              <p class="redtext" *ngIf="LeadCheckListEditModel.AssigneeId === '0' || LeadCheckListEditModel.AssigneeId === 0">
                  Assignee is required
              </p>
          </div>-->
                    <!--<ng-select formControlName="Assignee" [items]="assigneeList"
                     bindLabel="Name"
                     bindValue="Id"
                     [multiple]="true"
                     placeholder="Select Assignee"
                     [(ngModel)]="selectedAssignees">
          </ng-select>-->

                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Status
                      <span class="star">*</span>
                    </label>
                    <label class="select">
                      <label class="select">
                        <select class="form-control" formControlName="Status" (change)="onTaskStatusChange();" [(ngModel)]="LeadCheckListEditModel.Status">
                          <option *ngFor="let status of lookupList" [(ngValue)]="status.id">{{status.description}}</option>
                        </select>
                        <i></i>
                      </label>
                    </label>
                  </div>
                  <div class="form-group" *ngIf="LeadCheckListEditModel.Status === 2252">
                    <label class="form-label">
                      Completed Date
                      <span class="star">*</span>
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="txtCompletedDate" placement="top" [(ngModel)]="LeadCheckListEditModel.CompletedDate" class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="isCompletedDateInvalid">
                        <p class="redtext">
                          {{CompletedDateInvalidMessage}}
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="text-right">
                  <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
                  <button class="btn btn-success btn-lg" [disabled]="disableTaskEditSavebtn" (click)="UpdateTask(templatePhaseDateEditConfirmation,'deletemodal');">Save</button>
                </div>
              </div>

            </ng-template>

            <ng-template #AddTask class="pull-left">

              <div class="modal-header">
                <h4 class="modal-title pull-left">Add Task</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="onAddTaskCancel();">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form [formGroup]="AddTaskForm" autocomplete="off">
                  <div class="form-group">
                    <label class="form-label">Task Name<span class="star">*</span></label>
                    <input class="form-control" formControlName="Add_txtTaskname" [(ngModel)]="AddTaskModel.TaskName" maxlength="100" required type="text">
                    <div *ngIf="(Add_txtTaskname.invalid && isAddTaskFormSubmitted )||(Add_txtTaskname.invalid && (Add_txtTaskname.dirty || Add_txtTaskname.touched))">
                      <p class="redtext" *ngIf="Add_txtTaskname.errors.required">
                        Task Name is required
                      </p>
                      <p class="redtext" *ngIf="Add_txtTaskname.errors.spaceOnly">
                        The value cannot be only white spaces
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Start Date
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="Add_txtStartDate" [(ngModel)]="AddTaskModel.StartDate" class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="(Add_txtStartDate.invalid && isAddTaskFormSubmitted )||(Add_txtStartDate.invalid && (Add_txtStartDate.dirty || Add_txtStartDate.touched))">
                        <p class="redtext" *ngIf="AddTaskModel.StartDate =='Invalid Date' ">
                          Invalid Start Date
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      End Date
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="Add_txtEndDate" [(ngModel)]="AddTaskModel.EndDate" class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="(Add_txtEndDate.invalid && isAddTaskFormSubmitted )||(Add_txtEndDate.invalid && (Add_txtEndDate.dirty || Add_txtEndDate.touched))">
                        <p class="redtext" *ngIf="AddTaskModel.EndDate =='Invalid Date' ">
                          Invalid End Date
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Associated Category
                      <span class="star">*</span>
                    </label>
                    <label class="select">
                      <select formControlName="Add_AssociatedStatus" [(ngModel)]="AddTaskModel.AssociatedStatusId" class="form-control">
                        <option value="0">--Select--</option>
                        <option [ngValue]="asl.id" *ngFor="let asl of associatedStatusList">{{asl.description}}</option>
                      </select>
                      <i></i>
                    </label>
                    <div *ngIf="(isAddTaskFormSubmitted) || (Add_AssociatedStatus.dirty || Add_AssociatedStatus.touched)">
                      <p class="redtext" *ngIf="AddTaskModel.AssociatedStatusId === '0' || AddTaskModel.AssociatedStatusId === 0">
                        Associated Category is required
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Responsible Role
                      <!--<span class="star">*</span>-->
                    </label>
                    <label class="select">
                      <select [(ngModel)]="AddTaskModel.ResponsibleRoleId" formControlName="Add_UserRole" (change)="bindAssignee(AddTaskModel.ResponsibleRoleId,0)" class="form-control">
                        <option value="0">--Select--</option>
                        <option [ngValue]="item.id" *ngFor="let item of userRoleList">{{item.name}}</option>
                      </select>
                      <i></i>
                    </label>
                    <!--<div *ngIf="(isAddTaskFormSubmitted) || (Add_UserRole.dirty || Add_UserRole.touched)">
              <p class="redtext" *ngIf="AddTaskModel.ResponsibleRoleId === '0' || AddTaskModel.ResponsibleRoleId === 0">
                  Responsible Role is required
              </p>
          </div>-->
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Assignee
                      <!--<span class="star">*</span>-->
                    </label>
                    <label class="select">

                      <select [(ngModel)]="AddTaskModel.AssigneeId" formControlName="Add_Assignee" class="form-control">
                        <option value="0">--Select--</option>
                        <option [ngValue]="assignee.UserId" *ngFor="let assignee of assigneeList">{{assignee.UserName}}</option>
                      </select>
                      <i></i>
                    </label>

                    <!--<div *ngIf="(isAddTaskFormSubmitted) || (Add_Assignee.dirty || Add_Assignee.touched)">
              <p class="redtext" *ngIf="AddTaskModel.AssigneeId === '0' || AddTaskModel.AssigneeId === 0">
                  Assignee is required
              </p>
          </div>-->
                  </div>
                </form>
                <div class="text-right">
                  <button class="btn btn-default btn-lg" (click)="onAddTaskCancel();">Cancel</button>
                  <button class="btn btn-success btn-lg" [disabled]="disableSavebtn" (click)="onSaveTask()">Save</button>
                </div>
              </div>

            </ng-template>

            <ng-template #AddTaskPhase class="pull-left">

              <div class="modal-header">
                <h4 class="modal-title pull-left">Edit Associated Category Details</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="onPhaseEditCancel();">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form [formGroup]="EditPhaseForm" autocomplete="off">
                  <div class="form-group">
                    <label class="form-label">Associated Category<span class="star">*</span></label>
                    <input class="form-control" disabled name="Phase_txtPhasename" [(ngModel)]="PhaseInputModel.PhaseName" [ngModelOptions]="{standalone: true}" maxlength="100" required type="text">
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      Start Date
                      <span class="star">*</span>
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="Phase_txtStartDate" [(ngModel)]="PhaseInputModel.StartDate" required class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="(Phase_txtStartDate.invalid && isAddTaskFormSubmitted )||(Phase_txtStartDate.invalid && (Phase_txtStartDate.dirty || Phase_txtStartDate.touched))">
                        <p class="redtext" *ngIf="Phase_txtStartDate.errors.required">
                          Start Date is required
                        </p>
                        <p class="redtext" *ngIf="AddTaskModel.StartDate =='Invalid Date' ">
                          Invalid Start Date
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">
                      End Date
                      <span class="star">*</span>
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker formControlName="Phase_txtEndDate" [(ngModel)]="PhaseInputModel.EndDate" required class="form-control" type="text">
                      <i class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="(Phase_txtEndDate.invalid && isAddTaskFormSubmitted )||(Phase_txtEndDate.invalid && (Phase_txtEndDate.dirty || Phase_txtEndDate.touched))">
                        <p class="redtext" *ngIf="Phase_txtEndDate.errors.required">
                          End Date is required
                        </p>
                        <p class="redtext" *ngIf="AddTaskModel.EndDate =='Invalid Date' ">
                          Invalid End Date
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="custom-checkbox">
                      <input type="checkbox" formControlName="Phase_IsCompleted" (change)="onPhaseCompleted();" [(ngModel)]="PhaseInputModel.IsPhaseCompleted">
                      Completed
                      <i></i>
                    </label>
                  </div>

                  <div class="form-group" *ngIf="PhaseInputModel.IsPhaseCompleted">
                    <label class="form-label">
                      Completed Date
                      <span class="star">*</span>
                    </label>
                    <div class="textbox-date">
                      <input bsDatepicker #dp="bsDatepicker" formControlName="Phase_Completed" placement="top" [(ngModel)]="PhaseInputModel.CompletedDate" class="form-control" type="text">
                      <i (click)="dp.toggle()" class="icofont icofont-ui-calendar icon"></i>
                      <div *ngIf="isPhaseCompletedDateInvalid">
                        <p class="redtext">
                          Completed Date is required
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="text-right">
                  <button class="btn btn-default btn-lg" (click)="onPhaseEditCancel();">Cancel</button>
                  <button class="btn btn-success btn-lg" (click)="showDateChangePopup(templateDateEditConfirmation,'deletemodal')">Save</button>
                </div>
              </div>

            </ng-template>

            <ng-template #templateDateEditConfirmation>

              <div class="modal-header">
                <h4 class="modal-title pull-left">Delete Task</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefConfirmation.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body padding30">
                <div class="form-group">
                  <h6 class="displayvalue">Would you like to update all subsequent tasks?</h6>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-default margin-right-5" (click)="modalRefConfirmation.hide()">Cancel</button>
                  <button class="btn btn-border btn-lg margin-right-5" (click)="onPhaseEdit(false)">Update Selected</button>
                  <button class="btn btn-success btn-lg" (click)="onPhaseEdit(true)">Update All</button>
                </div>
              </div>
            </ng-template>
            <ng-template #templatePhaseDateEditConfirmation>

              <div class="modal-header">
                <h4 class="modal-title pull-left">Edit Task</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="UpdatePhaseDate();modalRefPhaseDateConfirmation.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body padding30">
                <div class="form-group">
                  <h6 class="displayvalue">The changes in the date will affect the dates of phase. Are you sure you want to continue?</h6>
                </div>
                <div class="text-right">
                  <button class="btn btn-lg btn-default margin-right-5" (click)="UpdatePhaseDate();modalRefPhaseDateConfirmation.hide()">Cancel</button>
                  <button class="btn btn-success btn-lg" (click)="modalRefPhaseDateConfirmation.hide();UpdateTask(templatePhaseDateEditConfirmation,'deletemodal')">Yes</button>
                </div>
              </div>
            </ng-template>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!tasksSaved && !loggedInUserIsPropertyBroker" class="nodata">
  <i class="fa fa-exclamation-triangle icon"></i>
  <p>Your task list is loading. Please wait..</p>
</div>

<div *ngIf="!taskAdded && showAssignTask && loggedInUserIsPropertyBroker">
  <app-assign-task (GoBack)="GoBack($event)" (TaskAssigned)=TaskAssigned($event)></app-assign-task>
</div>


